<template>
  <footer class="footer section section-light">
    <div class="container">
      <p class="copyright text-center mb-0">© Ahmed Zobayer 2021 | All Right Reserved</p>
    </div>
  </footer>
</template>

<script>

export default {
  data() {
    return {
      name: ''
    }
  },
  watch: {

  },
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/global/footer.vue